import { HttpClientImpl } from './http-client-impl';
import { BrowserHttpAdapter } from './http-browser-adapter';
export function browserClient(baseUrl) {
    return new HttpClientImpl(new BrowserHttpAdapter(), {
        baseUrl: baseUrl !== null && baseUrl !== void 0 ? baseUrl : '',
        query: {},
        body: null,
        headers: {},
        paths: [],
        middlewares: [],
    });
}
